// src/Careers.js
import React from 'react';
import './career.css';

const Career = () => {
  return (
    <section id="careers" className="careers">
      <div className="careers-content">
        <h1>Interested to work at NextOrbitals?</h1>
        <p>
          Here at NextOrbitals, there are endless challenges and opportunities to
           explore across the globe.
        </p>
        <p>
          Our teams are fueled by inspiration and collaboration. Our culture fosters innovation
           and values a peaceful and integral workplace. We’re made up of strong, smart, and
            hardworking people dedicated to doing our best work and becoming the source of
             driving success for our customers.
        </p>
        <p>
          We are looking for <strong>Sales Representatives/Agents</strong> from
           the <strong>INDIA </strong> on a commission basis to represent our company and
            market products in our basket for the Restaurants and hospitals.
        </p>
        <p>
          If interested, please get back to us with your updated CV/Resume -
        </p>
        <ul>
          <li>For India Location - <a href="mailto:hr@nextorbitals.in">hr@nextorbitals.in</a></li>
        </ul>
        <p>
          Feel free to suggest if you have any suitable contacts.
        </p>
      </div>
    </section>
  );
};

export default Career;